type TimeUnit =
  | 'minute'
  | 'hour'
  | 'day'
  | 'week'
  | 'month'
  | 'year'
  | 'just_now';

export function getTimeAgo(dateString: string): {
  value: number;
  unit: TimeUnit;
} {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) {
    return { value: 0, unit: 'just_now' };
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return { value: minutes, unit: 'minute' };
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return { value: hours, unit: 'hour' };
  }

  const days = Math.floor(hours / 24);
  if (days < 7) {
    return { value: days, unit: 'day' };
  }

  const weeks = Math.floor(days / 7);
  if (weeks < 4) {
    return { value: weeks, unit: 'week' };
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return { value: months, unit: 'month' };
  }

  const years = Math.floor(days / 365);
  return { value: years, unit: 'year' };
}
